<template>
	<v-row v-if="irrigators.length">
		<v-col>
			<v-btn class="primary" :disabled="noMore" @click="loadMore">{{
				buttonText
			}}</v-btn>
		</v-col>
	</v-row>
</template>

<script>
	import { mapActions, mapState } from 'vuex';
	export default {
		name: 'irrigator-list-pagination',

		data() {
			return {
				perPage: Number(process.env.VUE_APP_IRRIGATORS_PER_PAGE),
			};
		},

		computed: {
			...mapState({
				irrigators: state => state.irrigatorControl.irrigators,
				noMore: state => state.irrigatorControl.noMoreIrrigators,
				lastVisible: state =>
					state.irrigatorControl.irrigatorsLastVisible,
			}),

			buttonText() {
				return this.noMore
					? 'Fin de la lista'
					: `Cargar ${this.perPage} más de ${this.lastVisible.count}`;
			},
		},

		methods: {
			...mapActions('irrigatorControl', ['loadIrrigators']),

			loadMore() {
				this.loadIrrigators(this.lastVisible);
			},
		},
	};
</script>
